import { useState } from "react";
import { createPortal } from "react-dom";
import {
  MODELS,
  MUTATIONS,
  useModel,
  useMutation,
} from "../../../../../../api";
import IconButton from "../../../../../../design-system/components/IconButton/IconButton.jsx";
import Dialog from "../../../../../../design-system/components/Dialog/Dialog.jsx";
import { getConfirmAbortButtons } from "../../../../../../design-system/components/Confirm/ConfirmAbortButtons.jsx";
import styles from "./DeleteUserFromWorkshopButton.css.ts";

const DeleteUserFromWorkshopButton = ({ workshop, user }) => {
  const [open, setOpen] = useState(false);
  const me = useModel(MODELS.ME);
  const [doRemoveUserFromTeam] = useMutation(MUTATIONS.removeUserFromWorkshop);

  if (!me) return null;

  // Only admins or workshop owners can delete users
  if (!me.isAdmin && workshop.owner && workshop.owner.id !== me.id) return null;

  // You can not delete yourself
  if (me.id === user.id) return null;

  function handleConfirm() {
    setOpen(false);

    doRemoveUserFromTeam({
      userId: user.id,
      workshopId: workshop.id,
    });
  }

  function handleClick() {
    setOpen(true);
  }

  return (
    <>
      <div className={styles.iconButton}>
        <IconButton
          name="xmark"
          onClick={handleClick}
          title="Person entfernen"
        />
      </div>

      {createPortal(
        <Dialog
          open={open}
          setOpen={setOpen}
          title={`${user.name} entfernen?`}
          buttons={getConfirmAbortButtons(setOpen, handleConfirm)}
        >
          <p>
            Wenn du die Person entfernst, kann die Person nicht mehr auf die
            Lernreise zugreifen und müsste neu eingeladen werden.
          </p>
        </Dialog>,
        document.body,
      )}
    </>
  );
};

export default DeleteUserFromWorkshopButton;
